<template>
  <div>
    <div class="results_container">
      <expert-result-block
        v-if="user"
        :user="userComputed"
        :current-route-name="currentRouteName"
        :routes="routesComputed"
        :wpmessage="wpmessageComputed"
        :me="meComputed"
        :all-assignment-statuses="allAssignmentStatusesComputed"
        :questions="questions"
        @updated="getUsers"
      />
    </div>
  </div>
</template>
<script>
import mixin from "../../../mixins/mixin";
export default {
  mixins: [mixin],
  props: {
    userInit: {
      type: String,
      required: true,
    },
    currentRouteName: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    allAssignmentStatusesInit: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    attachedJobExperienceIdsInit: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    projectInit: {
      type: String,
      required: false,
      default() {
        return null;
      },
    },
    questionsInit: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      url: "/admin/experts/api/index",
      users: {},
      wpmessage: "",
      extraStringRaw: "",
      hideJobExperiences: false,
      searchStr: "",
      myUser: {},
      routes: [],
      allAssignmentStatuses: [],
      attachedJobExperienceIds: [],
      project: {},
      questions: [],
      user: null,
    };
  },
  computed: {
    userComputed() {
      return this.user;
    },
    routesComputed() {
      return this.routes || [];
    },
    wpmessageComputed() {
      return this.wpmessage || "";
    },
    meComputed() {
      return this.myUser;
    },
    allAssignmentStatusesComputed() {
      return this.allAssignmentStatuses || [];
    },
  },
  mounted() {
    const user = JSON.parse(this.userInit);
    this.user = user;
    this.getMyUser().then(u => (this.myUser = u));
    this.getPermittedRoutes().then(res => (this.routes = res));
    console.log(this.user.expert);
  },
  methods: {
    markString(str) {
      this.searchStr = str;
    },
    async getUsers(page = 1) {
      this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id, page });
    },
    setDisplayOptions(payload) {
      if (payload && payload.id == "hideJobExperiences") {
        this.hideJobExperiences = payload.status;
      }
    },
  },
};
</script>
